/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-alert */
import React, { useRef } from 'react';
import { DialogUtility } from '@syncfusion/ej2-popups';
import { TextAreaComponent, TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import kit from '../data/logo.png';

const Removal = () => {
  const { REACT_APP_API_ENDPOINT } = process.env;
  async function sendEmail(email, to, subject, message) {
    if (email && email.length > 5 && email.includes('@') && email.includes('.')) {
      fetch(`${REACT_APP_API_ENDPOINT}/email?recipient=${email}&to=${to}&subject=${subject}&message=${message}<br />Monaco Account Removal Form:<br />Please remove my account`, {
        method: 'GET',
        headers: {
        },
      })
        .then((response) => response.json())
        .then((responseJson) => {
          if (responseJson && responseJson.response && responseJson.response === 'OK') {
            DialogUtility.alert('Your request has been sent. Thank you!');
          } else {
            DialogUtility.alert(responseJson.response);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      DialogUtility.alert('Please enter a valid email address!');
    }
  }
  const messageRef = useRef(null);
  const submitEmail = () => {
    const email = document.getElementById('email').value;
    // const to = 'bbarrs@zackatlabs.com';
    const to = 'developer@zackat.com';
    const invite = document.getElementById('invite').value;
    // const company = document.getElementById('company').value;
    const subject = 'ZackatLabs Mobile App Account Removal';
    let msg = '';
    if (!email || email.length === 0 || !email.includes('@') || !email.includes('.')) {
      DialogUtility.alert('Please enter a valid email address!');
      return;
    }
    if (messageRef && messageRef.current) {
      msg = messageRef.current.value;
    }
    let message = 'Account Removal regarding ZackatLabs/Sensocore Mobile App';
    message += `<br />${invite}`;
    if (msg && msg.length > 0) {
      // message = `Name: ${name}<br />Company: ${company}<br />US State: ${location}\n<br />Services requested: ${services}<br />Customer Message: ${msg}`;
      message = `Invite: ${invite}<br />Customer Support Account Removal Message: ${msg}`;
    }
    sendEmail(email, to, subject, message);
  };
  return (
    <div className="home-container">
      <div className="contact-page-wrapper">
        <h1 className="primary-heading">Do you wish to have your account removed for the ZackatLabs Mobile App?</h1>
        <div className="flex">
          <label>Account Removal Request Form</label>
        </div>
        <div className="contact-form-wrapper" style={{ border: 'solid 2px', borderColor: '#78DA89', borderRadius: 10, backgroundColor: 'white' }}>
          <img src={kit} width={140} />
          <font color="red">*</font> indicates required fields
          <div className="flex">
            <label htmlFor="email">Email<font color="red">*</font></label>
            <TextBoxComponent
              value=""
              id="email"
              required
              name="email"
              cssClass="e-outline"
              placeholder="Email"
              floatLabelType="Auto"
            />
            <label htmlFor="invite">Invitation ID</label>
            <TextBoxComponent
              value=""
              id="invite"
              required
              name="invitation id"
              placeholder="Invitation ID"
              cssClass="e-outline"
              floatLabelType="Auto"
            />
          </div>
          <div className="flex mt-4">
            <label htmlFor="name">Message</label>
            <TextAreaComponent
              ref={messageRef}
              rows={5}
              maxLength={200}
              id="message"
              title="message"
              placeholder="Message"
              cssClass="e-outline"
              floatLabelType="Auto"
              value=""
            />
          </div>
          <div className="flex-end mr-4">
            <ButtonComponent cssClass="e-small" iconCss="e-icons e-save" style={{ float: 'right' }} onClick={submitEmail}>Submit</ButtonComponent>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Removal;
